import React, { useEffect, useState } from 'react';
import { Drawer } from 'react-daisyui';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // todo call the patient show request here to validate redux patient and response
  // redirect to session expired page and clear auth and everything there

  // The portal is a fixed app shell: only the content pane scrolls, so the
  // header and background stay put on mobile (otherwise the oversized 100vh
  // shell lets the page itself scroll under the browser chrome). Scoped to the
  // Layout so public pages (login, session-expired, …) keep normal scrolling.
  useEffect(() => {
    const body = document.body.style;
    const html = document.documentElement.style;
    const previous = { body: body.overflow, html: html.overflow };
    body.overflow = 'hidden';
    html.overflow = 'hidden';
    return () => {
      body.overflow = previous.body;
      html.overflow = previous.html;
    };
  }, []);

  return (
    <div className="h-screen supports-[height:100dvh]:h-dvh flex flex-col bg-[#f0f3f9] overflow-hidden p-3 gap-3">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100">
        <Header onMenuClick={() => setMobileMenuOpen(true)} />
      </div>

      {/* daisyUI Drawer: off-canvas overlay on mobile, inline sidebar on desktop (md:drawer-open) */}
      <Drawer
        open={mobileMenuOpen}
        onClickOverlay={() => setMobileMenuOpen(false)}
        side={
          <Sidebar
            onNavigate={() => setMobileMenuOpen(false)}
            onClose={() => setMobileMenuOpen(false)}
          />
        }
        // z-40 so the mobile overlay sits above the sticky header (z-30);
        // md:!h-full keeps the desktop sidebar within the shell instead of 100dvh.
        sideClassName="z-40 md:!h-full"
        contentClassName="min-h-0 md:pl-3"
        className="flex-1 min-h-0 overflow-hidden md:drawer-open grid-rows-[minmax(0,1fr)]"
      >
        <div className="h-full flex flex-col bg-white rounded-2xl shadow-sm border border-gray-100 overflow-y-auto overscroll-contain min-h-0">
          <main className="flex-1 flex flex-col p-5 lg:p-6">
            {children}
          </main>
        </div>
      </Drawer>
    </div>
  );
};
